var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type, Transform, Exclude, Expose } from 'class-transformer';
import moment from 'moment';
import { SecurityIOCFeedsFeedTypes as FeedTypes } from '@logz-pkg/enums';
import { ThreatsFeedPipelineModel as PipelineModel } from './threats-feed-pipeline';
export class ThreatsFeedManagementModel {
    id;
    name = null;
    description = '';
    severity = null;
    url = null;
    sourceUrl = '';
    iocType = null;
    enabled = true;
    fromTimeFieldName = '';
    fromTimePattern = '';
    apiKeyFieldName = '';
    apiKeyValue = '';
    compression = null;
    accountId;
    method = null;
    headers = null;
    body = null;
    pipeline;
    lastUpdatedOn;
    lastSuccessfulRun;
    get feedType() {
        return this.accountId === 0 ? FeedTypes.LOGZIO : FeedTypes.PRIVATE;
    }
}
__decorate([
    Expose({ name: 'pipelineId' }),
    Transform(value => value.id, { toPlainOnly: true }),
    Transform(id => ({ id }), { toClassOnly: true }),
    __metadata("design:type", PipelineModel)
], ThreatsFeedManagementModel.prototype, "pipeline", void 0);
__decorate([
    Type(() => Date),
    Transform(value => moment(value * 1000), { toClassOnly: true }),
    __metadata("design:type", Object)
], ThreatsFeedManagementModel.prototype, "lastUpdatedOn", void 0);
__decorate([
    Exclude({ toPlainOnly: true }),
    Type(() => Date),
    Transform(value => moment(value * 1000), { toClassOnly: true }),
    __metadata("design:type", Object)
], ThreatsFeedManagementModel.prototype, "lastSuccessfulRun", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], ThreatsFeedManagementModel.prototype, "feedType", null);
//# sourceMappingURL=threats-feed-management.js.map